import { IErrorResponse, IErrorResponsePayload, ErrorResponseData } from '../interface/iErrorResponse';

class ResponseError extends Error implements IErrorResponse<ErrorResponseData> {
    public data: ErrorResponseData;
    constructor({ url, response }: IErrorResponsePayload, error?: any) {
        super(
            response?.data?.error?.message || response?.data?.error?.msg || error?.message || error || 'Request Failed'
        );
        this.data = {
            url: url,
            code: response?.data?.error?.code || error?.code || response?.status || 'UNHANDLED_RESPONSE_ERROR',
            subCode: response?.data?.error?.subCode || '',
            description: response?.data?.error?.description || '',
            trackingEvent: response?.data?.error?.trackingEvent || '',
            errorDomain: response?.data?.error?.errorDomain || '',
            severity: response?.data?.error?.severity || '',
            apiIdentifier: response?.data?.error?.apiIdentifier || '',
            message:
                response?.data?.error?.msg ||
                response?.data?.error?.message ||
                error?.message ||
                error ||
                'Request Failed',
            status: response?.status || 400,
            statusText: response?.statusText || response?.status ? String(response?.status) : '400',
            errorFields: response?.data?.error?.errorFields || [],
        };
    }
}

export default ResponseError;
